import React from 'react'
import { observer } from 'mobx-react'
import AccessDeniedView from 'components/AccessDeniedView'
import { useDocumentTitle } from 'hooks/document-title'
import { useActivation } from 'hooks/mobx-hooks'
import { useScrollOffsetSpring } from 'hooks/spring-hooks'
import UserManagementTable from '../../components/UserManagementTable'
import UserManagementWorkspaceSwitcher from '../../components/UserManagementWorkspaceSwitcher'
import { ManageSkillsDialog } from '../ManageSkillsDialog'
import { WorkspaceInvitationDialog } from '../WorkspaceInvitationDialog'
import { UserManagementViewModel } from './UserManagementViewModel'
import styles from './UserManagement.sass'
import EditUserRoleDialog from '../EditUserRoleDialog'
import EditUserCapacityDialog from '../ManageUserCapacityDialog'
import RemoveFromWorkspaceDialog from '../RemoveFromWorkspaceDialog'
import RestoreToWorkspaceDialog from '../RestoreToWorkspaceDialog'

interface UserManagementProps {
  vm: UserManagementViewModel
}

export default observer(({ vm }: UserManagementProps) => {
  useDocumentTitle('User Management')
  const scrollRef = React.useRef<HTMLDivElement | null>(null)
  const scrollOffset = useScrollOffsetSpring(scrollRef)
  useActivation(vm)

  return vm.canAccessUserManagement ? (
    <div ref={scrollRef} className={styles.root}>
      <UserManagementWorkspaceSwitcher scrollOffset={scrollOffset} vm={vm} />

      <UserManagementTable vm={vm} />
      <EditUserRoleDialog vm={vm.editUserRoleVM} />
      <EditUserCapacityDialog vm={vm.manageUserCapacityVM} />
      <WorkspaceInvitationDialog vm={vm.workspaceInvitationVM} />
      <ManageSkillsDialog vm={vm.manageSkillsVM} />
      <RemoveFromWorkspaceDialog vm={vm.removeFromWorkspaceVM} />
      <RestoreToWorkspaceDialog vm={vm.restoreToWorkspaceVM} />
    </div>
  ) : (
    <AccessDeniedView data-test="user-management-access-denied" />
  )
})
